import React, { useEffect, useMemo, useState } from 'react';
import MainEntrance from '../components/MainEntrance';

export default function PCGames() {
  const entityType = 'pc';

  return (
    <MainEntrance entityType={entityType}/>
  );
}
